// test2928
(2928 && 0);
